import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.project.documents');
import { OnInit, Input, Output, EventEmitter, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-project-documents',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.project.documents/view.scss */
:host {
  display: block;
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out;
}
.accordion-content.expanded {
  max-height: 2000px;
  transition: max-height 0.5s ease-in;
}`],
})
export class ComponentProjectDocumentsComponent implements OnInit {
    @Input() documents: any[] = [];
    @Input() projectId: string = '';
    @Output() onAdd = new EventEmitter<void>();
    @Output() onDelete = new EventEmitter<any>();
    @Output() onDownload = new EventEmitter<any>();

    public isExpanded: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        if (this.documents.length > 0) this.isExpanded = true;
    }

    public async toggleExpand() {
        this.isExpanded = !this.isExpanded;
        await this.service.render();
    }

    public openAddModal(event: Event) {
        event.stopPropagation();
        this.onAdd.emit();
    }

    public isPdf(document: any): boolean {
        const filename = this.getFileName(document).toLowerCase();
        return filename.endsWith('.pdf');
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public formatFileSize(bytes: number): string {
        const size = Number(bytes || 0);
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    public getFileName(document: any): string {
        return document?.filename || document?.filepath?.split('/').pop() || '제목 없음';
    }

    public getFileIconClass(document: any): string {
        const filename = this.getFileName(document).toLowerCase();
        if (filename.endsWith('.pdf')) return 'fa-solid fa-file-pdf text-red-400';
        if (filename.endsWith('.doc') || filename.endsWith('.docx') || filename.endsWith('.hwp') || filename.endsWith('.hwpx')) return 'fa-solid fa-file-word text-blue-400';
        if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) return 'fa-solid fa-file-excel text-emerald-400';
        if (filename.endsWith('.ppt') || filename.endsWith('.pptx')) return 'fa-solid fa-file-powerpoint text-orange-400';
        if (filename.endsWith('.zip')) return 'fa-solid fa-file-zipper text-amber-400';
        return 'fa-solid fa-file-lines text-slate-400';
    }

    public download(document: any) {
        this.onDownload.emit(document);
    }

    public async deleteItem(document: any) {
        const confirmed = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 계약 관련 서류를 삭제하시겠습니까?',
            status: 'warning',
            action: '삭제',
            actionBtn: 'danger',
            cancel: '취소'
        });
        if (!confirmed) return;
        this.onDelete.emit(document);
    }
}

export default ComponentProjectDocumentsComponent;